import { PayloadAction, createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit";

import { apiRequest } from "services/ServiceUtil";
import {
  LIBRARY_SERVICE_METHOD,
  RECOMMNDATION_SERVICE_METHOD,
  USER_PLAN_SERVICE_METHOD,
  USER_SERVICES_METHOD
} from "services/commonService";
import { PAGE_SIZE } from "utils/CommonConstants";
import { SuggestedPlanState } from "../library/SuggestedPlans/SuggestedPlans";

const SLICE = "HotelUserDashboard";

const isHotelUserDashboardThunk = (action: any) => action.type.startsWith(`${SLICE}/`); // This is chech fullfilled and rejected cases only for HotelUserDashboard Slice.

const SuggestedPlans: SuggestedPlanState = {
  listIds: [],
  totalRecords: 0,
  SuggestedPlansList: [],
  newAreaOfFocusesAvailable: false,
  removeInvalidPlan: {},
  loadingCount: 0,
  plansMetrics: [],
  selectedFocusAreas: [],
  metricsPlansIds: [],
  metricsPlansList: []
};

const initialState: any = {
  loadingCount: 0,
  externalUser: {
    userDetails: {},
    innCodeDetails: {}
  },
  statistics: {},
  myPlansOverview: {},
  suggestedPlans: SuggestedPlans,
  dashboardMetrics: {},
  metricsList: [],
  brandDeadlines: {
    list: []
  },
  teamProgressDetails: {},
  dashboardWidgetPreference: null,
  isReorderDialogOpen: false,
  assignedPlans: { list: [] },
  associateMetadata: {},
  selectedTabs: {
    suggestedPlans: 0
  },
  dateRangeFilter: {
    createdDateFrom: null,
    createdDateTo: null
  }
};

export const fetchSuggestedPlansIdAsync = createAsyncThunk(
  `${SLICE}/fetchSuggestedPlansIdAsync`,
  (data: any, thunkApi) => {
    const params = { innCode: data.innCode, externalHltId: data?.externalHltId || "" };
    return apiRequest(RECOMMNDATION_SERVICE_METHOD.putSuggestedPlans, {}, thunkApi, [], params);
  }
);

export const fetchSuggestedPlansAsync = createAsyncThunk(`${SLICE}/fetchSuggestedPlansAsync`, (data: any, thunkApi) => {
  const params = { externalHltId: data?.externalHltId || "" };
  return apiRequest(LIBRARY_SERVICE_METHOD.postPlans, data, thunkApi, [], params);
});

export const fetchMeticsPlansIdsAsync = createAsyncThunk(`${SLICE}/fetchMeticsPlansIdsAsync`, (data: any, thunkApi) => {
  const params = { innCode: data.innCode };
  return apiRequest(RECOMMNDATION_SERVICE_METHOD.putSuggestedPlans, data.payload, thunkApi, [], params);
});

export const fetchMetricsList = createAsyncThunk(`${SLICE}/fetchMetricsList`, (data: any, thunkApi) => {
  const params = { innCode: data.innCode };
  return apiRequest(RECOMMNDATION_SERVICE_METHOD.getMetrics, {}, thunkApi, [], params);
});

export const fetchDashboardReportAsync = createAsyncThunk(`${SLICE}/fetchDashboardReportAsync`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.getDashboardReport, {}, thunkApi, [], data)
);

export const fetchMyPlansOverviewAsync = createAsyncThunk(`${SLICE}/fetchMyPlansOverviewAsync`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.getPlanOverviewReport, {}, thunkApi, [], data)
);

export const fetchAssignedPlansAsync = createAsyncThunk(`${SLICE}/fetchAssignedPlansAsync`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.postAbovePropertyPlans, data.payload, thunkApi, [], {
    page: data.page,
    size: PAGE_SIZE
  })
);

export const fetchBrandDeadlinePlansAsync = createAsyncThunk(
  `${SLICE}/fetchBrandDeadlinePlansAsync`,
  (data: any, thunkApi) => {
    const queryParam = { externalHltId: data?.externalHltId || "" };
    return apiRequest(LIBRARY_SERVICE_METHOD.postDashboardPlans, data, thunkApi, [], queryParam);
  }
);

export const fetchTeamMemberProgressAsync = createAsyncThunk(
  `${SLICE}/fetchTeamMemberProgressAsync`,
  (data: any, thunkApi) => apiRequest(USER_PLAN_SERVICE_METHOD.getTeamMemberProgress, {}, thunkApi, [], data)
);

export const fetchTeamMemberDetailsAsync = createAsyncThunk(
  `${SLICE}/fetchTeamMemberDetailsAsync`,
  (data?: any, thunkApi?: any) => apiRequest(USER_SERVICES_METHOD.getAssociates, {}, thunkApi, [], data)
);

export const fetchAssociatesMetadata = createAsyncThunk(
  `${SLICE}/fetchAssociatesMetadata`,
  (data?: any, thunkApi?: any) => apiRequest(USER_SERVICES_METHOD.getAssociatesMetadata, {}, thunkApi)
);

export const patchAssociatesMetadata = createAsyncThunk(
  `${SLICE}/patchAssociatesMetadata`,
  (data?: any, thunkApi?: any) => {
    return apiRequest(USER_SERVICES_METHOD.patchAssociatesMetadata, data.payload, thunkApi, [], {
      update_type: data?.update_type
    });
  }
);

export const fetchExternalUserDetailsAsync = createAsyncThunk(
  `${SLICE}/fetchExternalUserDetailsAsync`,
  (data?: any, thunkApi?: any) => apiRequest(USER_SERVICES_METHOD.getAssociates, {}, thunkApi, [], data)
);

export const HotelUserDashboard = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: (state) => {
      return {
        ...initialState,
        dashboardWidgetPreference: state.dashboardWidgetPreference,
        associateMetadata: state.associateMetadata,
        suggestedPlans: { ...initialState.suggestedPlans, plansMetrics: state.suggestedPlans.plansMetrics },
        externalUser: state.externalUser,
        dateRangeFilter: state.dateRangeFilter
      };
    },
    setDashboardWidgetPreference: (state, action) => {
      state.dashboardWidgetPreference = action.payload;
    },
    setOpenReorderSection: (state, action) => {
      state.isReorderDialogOpen = action.payload;
    },
    setSuggestedPlanList(state) {
      state.suggestedPlans.SuggestedPlansList = [];
    },
    resetSuggestedListIds(state) {
      state.suggestedPlans.listIds = [];
    },
    resetMetricsPlansIds(state) {
      state.suggestedPlans.metricsPlansIds = [];
    },
    setSelectedTab(state, action) {
      const { page, val } = action.payload;
      state.selectedTabs[page] = val;
    },
    setUserExperienceLevel: (state, action) => {
      state.associateMetadata = { ...state.associateMetadata, experienceLevel: action?.payload };
    },
    setCreatedDate: (state, action) => {
      state.dateRangeFilter = action?.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuggestedPlansIdAsync.fulfilled, (state, action: any) => {
        state.suggestedPlans.newAreaOfFocusesAvailable = action.payload.newAreaOfFocusesAvailable;
        state.suggestedPlans.selectedFocusAreas = action.payload.selectedFocusAreas;
        state.suggestedPlans.plansMetrics = [...action.payload.suggestedPlans];
        if (action.payload.suggestedPlans.length) {
          state.suggestedPlans.listIds = action.payload.suggestedPlans;
        }
        state.dashboardMetrics = action.payload.metrics;
      })
      .addCase(fetchSuggestedPlansIdAsync.rejected, (state, action) => {
        state.suggestedPlans.listIds = [];
        state.suggestedPlans.SuggestedPlansList = [];
      })
      .addCase(fetchSuggestedPlansAsync.fulfilled, (state, action: any) => {
        state.suggestedPlans.SuggestedPlansList =
          action.meta.arg.pagination.page === 1
            ? action.payload.plans
            : [...state.suggestedPlans.SuggestedPlansList, ...action.payload.plans];
        state.suggestedPlans.totalRecords = action.payload.meta?.page?.total;
      })
      .addCase(fetchDashboardReportAsync.fulfilled, (state, action: PayloadAction<any>) => {
        state.statistics = action.payload;
      })
      .addCase(fetchMyPlansOverviewAsync.fulfilled, (state, action: any) => {
        state.myPlansOverview.list =
          action.meta.arg.page === 0
            ? action.payload.PLANS_OVERVIEW
            : [...state.myPlansOverview.list, ...action.payload.PLANS_OVERVIEW];
        state.myPlansOverview.totalRecords = action?.payload?.meta?.page?.total;
      })

      .addCase(fetchMeticsPlansIdsAsync.fulfilled, (state, action: PayloadAction<any>) => {
        state.suggestedPlans.metricsPlansIds = action.payload.suggestedPlans;
        state.suggestedPlans.plansMetrics = [...action.payload.suggestedPlans];
      })
      .addCase(fetchBrandDeadlinePlansAsync.fulfilled, (state, action: any) => {
        state.brandDeadlines.list =
          action.meta.arg.pagination.page === 1
            ? action.payload.plans
            : [...state.brandDeadlines.list, ...action.payload.plans];
        state.brandDeadlines.totalRecords = action?.payload?.meta?.page?.total;
      })

      .addCase(fetchMetricsList.fulfilled, (state, action: any) => {
        state.metricsList = action.payload.innCodeMetrics?.[0]?.metrics;
      })

      .addCase(fetchTeamMemberProgressAsync.fulfilled, (state, action: PayloadAction<any>) => {
        state.teamProgressDetails = action.payload;
      })
      .addCase(fetchTeamMemberDetailsAsync.fulfilled, (state, action: PayloadAction<any>) => {
        state.teamProgressDetails.teamMemberDetails = action.payload.users || [];
      })

      .addCase(fetchExternalUserDetailsAsync.fulfilled, (state, action) => {
        state.externalUser.userDetails = action.payload?.users[0];
        state.externalUser.innCodeDetails = action.payload?.users[0]?.innCodes.map((i: any) => ({ innCode: i }));
      })
      .addCase(fetchAssignedPlansAsync.fulfilled, (state, action: any) => {
        state.assignedPlans.list =
          action.meta.arg.page === 0
            ? action.payload.userplans
            : [...state.assignedPlans.list, ...action.payload.userplans];
        state.assignedPlans.totalRecords = action?.payload?.meta?.page?.total;
      })
      .addCase(fetchAssociatesMetadata.fulfilled, (state, action: any) => {
        state.associateMetadata = action?.payload;
      })
      .addCase(patchAssociatesMetadata.fulfilled, (state, action: any) => {
        state.associateMetadata = action?.payload;
      })
      .addMatcher(
        (action) => isPending(action) && isHotelUserDashboardThunk(action),
        (state, action) => {
          if (
            // turn on loader if api is not paginated or it is for 1st page
            !("pagination" in action.meta.arg || "page" in action.meta.arg) ||
            action.meta?.arg?.pagination === 1 ||
            action.meta?.arg?.page === 0
          ) {
            state.loadingCount += 1;
          }
        }
      )
      .addMatcher(
        (action) => (isFulfilled(action) || isRejected(action)) && isHotelUserDashboardThunk(action),
        (state, action) => {
          if (
            !("pagination" in action.meta.arg || "page" in action.meta.arg) ||
            action.meta?.arg?.pagination === 1 ||
            action.meta?.arg?.page === 0
          ) {
            state.loadingCount -= 1;
          }
        }
      );
  }
});

export const {
  reset,
  setDashboardWidgetPreference,
  setOpenReorderSection,
  setSuggestedPlanList,
  resetSuggestedListIds,
  resetMetricsPlansIds,
  setSelectedTab,
  setUserExperienceLevel,
  setCreatedDate
} = HotelUserDashboard.actions;

export default HotelUserDashboard.reducer;
